import React from 'react';

const integrations = [
  'QuickBooks',
  'Stripe',
  'Google Maps',
  'Samsara',
  'Motive',
  'Twilio',
  'Slack',
  'CSV Import',
];

const Integrations = () => {
  return (
    <section className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-blue-600 mb-3">
          Integrations
        </p>
        <h2 className="text-4xl font-bold text-gray-900 mb-12">
          Works With Your Stack
        </h2>

        <div className="flex flex-wrap justify-center gap-6 max-w-3xl mx-auto">
          {integrations.map((name) => (
            <div
              key={name}
              className="w-24 h-24 bg-gray-50 rounded-xl border border-gray-200 flex items-center justify-center p-4 hover:shadow-md hover:-translate-y-1 hover:border-blue-200 transition-all duration-200 cursor-default"
            >
              <span className="text-xs font-medium text-gray-600 text-center leading-tight">
                {name}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a
            href="mailto:support@loadapp.com"
            className="text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors"
          >
            Don&apos;t see yours? Request an Integration →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Integrations;
